module.exports = __webpack_public_path__ + "static/media/slider-home-architecture-slide-01-image-01.269c71f6.jpg";